import {SlDialog} from '../../../../vendor/plugins/clxFrontendCms/public/js/shoelace/shoelace';

export class PraemienHandler {
    private readonly viewRoot: HTMLElement;

    constructor(viewRoot: HTMLElement) {
        this.viewRoot = viewRoot;

        this.initEventListeners();
    }

    private initEventListeners() {
        this.initDialogEventListeners();
        this.handlePraemienSelect();
        this.handlePraemienDelete();
        this.handleColorChange();
    }

    private initDialogEventListeners() {
        const dialog = this.viewRoot.querySelector('.layer-praemen-box') as SlDialog | null;
        if (!dialog) {
            return;
        }

        dialog.addEventListener('sl-show', (event) => {
            const target = event.target as HTMLElement;
            if (target.localName === 'sl-details') {
                [...dialog.querySelectorAll('sl-details')].map((details) => (details.open = event.target === details));
            }
        });

        // tarifdetail - oeffnen vom praemienlayer
        const dialogTrigger = this.viewRoot.querySelector('.open-praemen-box');
        if (!dialogTrigger) {
            return;
        }

        dialogTrigger.addEventListener('click', (event) => {
            event.preventDefault();
            dialog.show();
        });
    }

    private handlePraemienSelect() {
        const praemien: NodeListOf<HTMLElement> = this.viewRoot.querySelectorAll('.vt-select-praemie');
        praemien.forEach((praemie) => {
            praemie.addEventListener('click', (event) => {
                const target = event.target as HTMLElement;
                if (target.tagName.toLowerCase() === 'a') {
                    return;
                }

                event.preventDefault();
                event.stopImmediatePropagation();

                document.body.classList.add('loading');

                const art = praemie.dataset.art ?? '';
                const vtid = praemie.dataset.vtid ?? '';
                const value = praemie.dataset.value ?? '';
                const typ = praemie.dataset.typ ?? '';

                fetch('/tarif/select-praemie/' + vtid + '/' + art + '/' + value + '/' + typ, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    cache: 'default',
                    credentials: 'same-origin',
                })
                    .then((response) => response.json())
                    .then(() => {
                        window.location.reload();
                    });
            });
        });
    }

    private handlePraemienDelete() {
        const vtClearPraemien: NodeListOf<HTMLAnchorElement> = this.viewRoot.querySelectorAll('.vt-clear-praemie');
        vtClearPraemien.forEach((praemie) => {
            praemie.addEventListener('click', (event) => {
                event.preventDefault();

                document.body.classList.add('loading');

                const vtid = praemie.dataset.vtid ?? '';
                fetch('/tarif/vt-clear-praemie/' + vtid, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    cache: 'default',
                    credentials: 'same-origin',
                })
                    .then((response) => response.json())
                    .then(() => {
                        window.location.reload();
                    });
            });
        });
    }

    private handleColorChange() {
        var vtChangeArtPraemien: NodeListOf<HTMLLIElement> = this.viewRoot.querySelectorAll('.vt-change-art-praemie ul li');
        vtChangeArtPraemien.forEach((praemie) => {
            praemie.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();

                document.body.classList.add('loading');
                var container = praemie.closest('.vt-change-art-praemie') as HTMLDivElement;

                const art = container.dataset.art ?? '';
                const vtid = container.dataset.vtid ?? '';
                const value = praemie.dataset.artid ?? '';
                const typ = container.dataset.typ ?? '';

                fetch('/tarif/select-praemie/' + vtid + '/' + art + '/' + value + '/' + typ, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    cache: 'default',
                    credentials: 'same-origin',
                })
                    .then((response) => response.json())
                    .then(() => {
                        window.location.reload();
                    });
            });
        });
    }
}
